import { render, staticRenderFns } from "./StaticPage4.vue?vue&type=template&id=3f5ab80e&scoped=true"
import script from "./StaticPage4.vue?vue&type=script&lang=js"
export * from "./StaticPage4.vue?vue&type=script&lang=js"
import style0 from "./StaticPage4.vue?vue&type=style&index=0&id=3f5ab80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ab80e",
  null
  
)

export default component.exports